export default __webpack_public_path__ + "static/media/playlists.cbc26b1d.svg";